import React, {useCallback} from 'react';
import {createReactMapboxControl} from '../../../utils/mapbox/Mapbox';
import SearchBox, {SearchBoxProps} from '../../SearchBox';

export interface SearchBoxControlProps extends Omit<SearchBoxProps, 'onSearchResultSelected'> {
    onSearchResultChange: SetState<SearchResult | undefined>;
}

export default createReactMapboxControl(({
    onSearchResultChange,
    ...props
}: SearchBoxControlProps) => {

    const onSearchResultSelected = useCallback((event, data) => {
        onSearchResultChange(data.suggestion);
    }, [onSearchResultChange]);

    return <SearchBox {...props} onSearchResultSelected={onSearchResultSelected} />;
});
